// DAS-2142: Reusable clickable ticker chip for the PA module.
// DAS-2159: Enhanced with green/red signal icons via TickerSignalContext.
// On the Redux route (source !== 'file_drop'), clicking opens SearchResultModal.
// On the file_drop route, renders a plain non-interactive chip.

import React, { useState, useContext } from 'react';
import { Chip, Tooltip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ThreeTablesModal from '../SearchResultModal';
import getUserId from '../../functions/getUserId';
import { TickerSignalContext } from './TickerSignalContext';

const ClickableTickerChip = ({ ticker, source }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const isClickable = source !== 'file_drop' && !!ticker && ticker !== '—';
  const tickerSignals = useContext(TickerSignalContext);
  const signals = tickerSignals[(ticker || '').toUpperCase()] || {};

  const chipElement = isClickable ? (
    <Chip
      label={ticker}
      size="small"
      color="primary"
      variant="outlined"
      onClick={(e) => { e.stopPropagation(); setModalOpen(true); }}
      sx={{
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        '&:hover': {
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          borderColor: 'primary.main',
        },
      }}
    />
  ) : (
    <Chip label={ticker || '—'} size="small" color="primary" variant="outlined" />
  );

  return (
    <>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
        {chipElement}
        {signals.hasGreen && (
          <Tooltip title={signals.greenReasons.join(' · ')} arrow>
            <WarningAmberIcon sx={{ color: '#52c41a', fontSize: 14, ml: 0.25 }} />
          </Tooltip>
        )}
        {signals.hasRed && (
          <Tooltip title={signals.redReasons.join(' · ')} arrow>
            <WarningAmberIcon sx={{ color: '#ff4d4f', fontSize: 14, ml: 0.25 }} />
          </Tooltip>
        )}
      </span>
      {isClickable && modalOpen && (
        <ThreeTablesModal
          tickerValue={ticker}
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          userId={getUserId()}
        />
      )}
    </>
  );
};

export default ClickableTickerChip;
